<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
                <!-- <div class="card-header bg-transparent pb-5">
                    <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                    <div class="btn-wrapper text-center">
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                            <span class="btn-inner--text">Github</span>
                        </a>
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                            <span class="btn-inner--text">Google</span>
                        </a>
                    </div>
                </div> -->
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        <h1>ลืมรหัสผ่าน</h1>
                    </div>
                    <form role="form"> 
                        <!-- <div class="col-12">
                            <b> กรุณากรอกอีเมล </b>
                       </div> -->
                        
                        <base-input class="input-group-alternative mb-3"
                                    type="email"
                                    name="email"
                                    placeholder="name@example.com"
                                    addon-left-icon="ni ni-email-83"
                                    v-model="email" >
                                     <!-- v-click-outside="checkmail()"> -->
                        </base-input>

                        <!-- <div class="col-md-6">
                            <base-input placeholder="Success" :valid="true"></base-input>
                        </div>
                        <div class="col-md-6">
                            <base-input placeholder="Error input" :valid="false"></base-input>
                        </div> -->

                        <!-- <base-input class="input-group-alternative"
                                    placeholder="รหัสผ่าน"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="model.password" v-on:keyup.enter="login">
                        </base-input> -->

                    <!--     <base-checkbox class="custom-control-alternative">
                            <span class="text-muted">Remember me</span>
                        </base-checkbox> -->
                        <div class="text-center">
                            <base-button type="primary" class="my-4" v-on:click="checkmail()">Send</base-button>
                            <!-- <button type="submit" name="button">เข้าสู่ระบบ</button> -->
                        </div>
                    </form>
                      <div v-if="this.alert_success.status == true" class="alert alert-success" role="alert" style="text-align:center; font-size:15px">
                        <b>ระบบส่งข้อความไปที่อีเมลนี้แล้ว กรุณาตรวจสอบ </b>
                      </div>
                     <div v-if="this.alert_err.status == true" class="alert alert-warning" role="alert" style="text-align:center; font-size:15px">
                        <b>{{this.alert_err.text}}</b>
                     </div>
                </div>
            </div>
            <div class="row mt-3">
                <!-- <div class="col-6">
                    <a href="#" class="text-light"><small>ลืมรหัสผ่าน?</small></a>
                </div> -->
                <!-- <div class="col-6 text-right">
                    <router-link to="/register" class="text-light"><small>สร้างบัญชีใหม่</small></router-link>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
  import JwService from '../service/justwash';

  export default {
    name: 'remember',
    data() {
      return {
        email : '',
        alert_err: {
            status: false,
            text: '',
        },
         alert_success: {
            status: false,
            text: '',
        },
      }
    },
    methods: {
       
      checkmail: async function() {
        //   console.log(this.email);
           if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
                //   alert('ถูก')
                 this.alert_err.status = false;
           await axios({
              method: "post",
              url: JwService.getAPI()+ "/api/method/justwash.OwnerApi.FindUsername",
              data: {username: this.email},
            })
              .then((response) => {
               if (response.data.message.status == true) {
                    this.alert_success.status = true;
                    // console.log(response.data.message);
               } else {
                    // console.log(response.data.message);
                    this.alert_err.text = response.data.message.message;
                    this.alert_err.status = true;
               }
              
            })
              .catch((error) => {
                // console.log(error);
                this.$router.push("/login");
              });
            } else {
                 this.alert_success.status = false;
                 this.alert_err.status = true;
                 this.alert_err.text = 'อีเมลของคุณไม่ถูกต้อง';
            }
        }
    }
  }
</script>
<style>
</style>
